/* istanbul ignore file */
import { useUiTheme } from 'framework/uiTheme';
import { BaseFieldLayoutType, FieldProps, useFieldHelper } from 'framework/ui/field';
import type { Area } from 'domain/shared/career';

const CompetencyAreasField = (props: FieldProps<Area[]>) => {
  const { getValue, getLabel } = useFieldHelper(props);
  const { BaseFieldLayout } = useUiTheme<BaseFieldLayoutType>();

  const areas: Area[] = getValue() || [];
  const displayedAreas = (
    <ul>
      {areas.map((area: Area) => (
        <li key={area.id}>{area.name}</li>
      ))}
    </ul>
  );
  return <BaseFieldLayout label={getLabel()} value={displayedAreas} />;
};

export default CompetencyAreasField;
